var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMc = function SvgMc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0L36 0C38.2091 0 40 1.79086 40 4V24C40 26.2091 38.2091 28 36 28H4C1.79086 28 0 26.2091 0 24L0 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2856 20.0166C18.9238 21.2163 17.1573 21.9405 15.2271 21.9405C10.92 21.9405 7.42847 18.3348 7.42847 13.887C7.42847 9.43916 10.92 5.8335 15.2271 5.8335C17.1573 5.8335 18.9238 6.55771 20.2856 7.75737C21.6474 6.55771 23.4139 5.8335 25.3442 5.8335C29.6512 5.8335 33.1428 9.43916 33.1428 13.887C33.1428 18.3348 29.6512 21.9405 25.3442 21.9405C23.4139 21.9405 21.6474 21.2163 20.2856 20.0166Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2856 20.0166C21.9624 18.5394 23.0257 16.3414 23.0257 13.887C23.0257 11.4325 21.9624 9.23453 20.2856 7.75737C21.6474 6.55771 23.4139 5.8335 25.3442 5.8335C29.6512 5.8335 33.1428 9.43916 33.1428 13.887C33.1428 18.3348 29.6512 21.9405 25.3442 21.9405C23.4139 21.9405 21.6474 21.2163 20.2856 20.0166Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2857 7.75732C21.9624 9.23448 23.0257 11.4325 23.0257 13.8869C23.0257 16.3413 21.9624 18.5393 20.2857 20.0165C18.6089 18.5393 17.5457 16.3413 17.5457 13.8869C17.5457 11.4325 18.6089 9.23448 20.2857 7.75732Z",
    fill: "#FF5E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H36V-0.5H4V0.5ZM39.5 4V24H40.5V4H39.5ZM36 27.5H4V28.5H36V27.5ZM0.5 24V4H-0.5V24H0.5ZM4 27.5C2.067 27.5 0.5 25.933 0.5 24H-0.5C-0.5 26.4853 1.51472 28.5 4 28.5V27.5ZM39.5 24C39.5 25.933 37.933 27.5 36 27.5V28.5C38.4853 28.5 40.5 26.4853 40.5 24H39.5ZM36 0.5C37.933 0.5 39.5 2.067 39.5 4H40.5C40.5 1.51472 38.4853 -0.5 36 -0.5V0.5ZM4 -0.5C1.51472 -0.5 -0.5 1.51472 -0.5 4H0.5C0.5 2.067 2.067 0.5 4 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "MC.e92b90f446620871d6cacbb7be854918.svg";